import axios from 'axios';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import InquiryService from '../../../service/inquiry/inquiry';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';

const FloatingInquiry = () => {
  // const [modal['inquiry'], modalDispatch] = useState(false); // 기본은 false

  const { modal, modalDispatch } = useModal();

  const [type, setType] = useState('');
  const [email, setEmail] = useState('');
  const [onDrop, setOnDrop] = useState(false);
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (modal['inquiry']) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [modal['inquiry']]);

  const Submit = async () => {
    setLoading(true);
    try {
      const data = {
        email: email,
        category: type,
        content: content,
      };
      await InquiryService.inquiry(data);
      alert('문의가 접수되었습니다. 빠른 시일 내에 답변드리겠습니다.');
      modalDispatch({ type: 'I' });
      setEmail('');
      setContent('');
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('문의 접수에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  const isFormComplete = email && content && email.includes('@');
  const isLoggedIn = isLogin();

  if (!isLoggedIn) return null;

  return (
    <Container showInquiryPopUp={modal['inquiry']}>
      {!modal['inquiry'] ? (
        <img
          src="/assets/images/InqueryFloatingButton.svg"
          alt="Inquiry"
          onClick={() => modalDispatch({ type: 'I' })}
          style={{ cursor: 'pointer' }}
        />
      ) : (
        <Overlay>
          <PopupWrapper>
            <Popup>
              <TitleBox>
                <Title>문의하기</Title>
                <CloseButton
                  onClick={() => {
                    modalDispatch({ type: 'I' });
                    setEmail('');
                    setContent('');
                  }}
                >
                  <img
                    src="/assets/images/close/close-dark-gray.svg"
                    alt="Close"
                  />
                </CloseButton>
              </TitleBox>
              <ContentBox>
                <InputBox>
                  <InputItem>
                    <InputTitle>답변받으실 이메일</InputTitle>
                    <Input
                      placeholder="회신 받을 이메일을 입력해주세요."
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <SubItem>
                      <SubTitle>정확한 이메일 주소를 기입해 주세요.</SubTitle>
                    </SubItem>
                    {!email.includes('@') && email.length > 0 && (
                      <InputError>이메일 형식이 올바르지 않습니다.</InputError>
                    )}
                  </InputItem>
                  <InputItem>
                    <InputTitle>문의 유형</InputTitle>
                    <Drop onDrop={onDrop} onClick={() => setOnDrop(!onDrop)}>
                      <span>{type || '유형 선택'}</span>
                      <img
                        src="/assets/images/arrow/arrow-down-gray.svg"
                        alt="Inquiry"
                        style={{
                          width: '24px',
                          height: '24px',
                        }}
                      />
                    </Drop>
                    <div style={{ position: 'relative' }}>
                      {onDrop && (
                        <Dropdown_List>
                          {[
                            '서비스 오류 제보',
                            '이용/기능 문의',
                            '결제/멤버십 문의',
                            '멤버십 환불 문의',
                            '계정/로그인 문의',
                            '기타',
                          ].map((item, index) => (
                            <Dropdown_Item
                              key={index}
                              onClick={() => {
                                setType(item);
                                setOnDrop(false);
                              }}
                            >
                              <Dropdown_Item_Text>{item}</Dropdown_Item_Text>
                            </Dropdown_Item>
                          ))}
                        </Dropdown_List>
                      )}
                    </div>
                  </InputItem>
                  <InputItem>
                    <InputTitle>
                      <span>문의내용</span>
                    </InputTitle>
                    <Textarea
                      placeholder="땅집고옥션 이용 중에 생긴 불편한 사항이나 문의사항을 남겨주세요."
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                      maxLength={1000}
                    />
                    <ContentMaxLength>
                      <span style={{ color: 'black' }}>{content.length}</span> /
                      1000
                    </ContentMaxLength>
                  </InputItem>
                </InputBox>
              </ContentBox>
              <SubmitButtonContainer>
                <SubmitButton
                  disabled={!isFormComplete}
                  isComplete={!!isFormComplete}
                  onClick={Submit}
                >
                  {loading ? '로딩 중...' : '접수'}
                </SubmitButton>
              </SubmitButtonContainer>
            </Popup>
          </PopupWrapper>
        </Overlay>
      )}
    </Container>
  );
};

export default FloatingInquiry;

const Container = styled.div<{ showInquiryPopUp: boolean }>`
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 1100;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1100;
  background-color: rgba(0, 0, 0, 0.52);
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const PopupWrapper = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const Popup = styled.div`
  width: 100%;
  height: 90%;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  background-color: #fff;
  display: flex;
  flex-direction: column;
`;

const TitleBox = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 9px 16px;
  box-sizing: border-box;
`;

const Title = styled.div`
  flex: 1;
  text-align: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #171e26;
`;

const CloseButton = styled.div`
  cursor: pointer;
  margin-right: 16px;
`;

const ContentBox = styled.div`
  width: 100%;
  height: calc(100% - 150px);
  padding: 16px 16px 48px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  overflow-y: auto;
`;

const InputBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const InputItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const InputTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 700;
  color: #616161;
  margin-bottom: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const SubItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #eaf2fe;
  height: 35px;
  padding: 8px 12px;
  border-radius: 4px;
`;

const SubTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  color: #616161;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Drop = styled.div<{ onDrop: boolean }>`
  width: 100%;
  padding: 13px;
  border: ${({ onDrop }) =>
    onDrop ? '1px solid #008AFF' : '1px solid rgba(23, 30, 38, 0.1)'};
  border-radius: 5px;
  font-size: 14px;
  font-color: #222222;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  user-select: none;
  align-items: center;
  justify-content: space-between;
`;

const Input = styled.input`
  width: 100%;
  padding: 13px;
  border: 1px solid rgba(23, 30, 38, 0.1);
  border-radius: 5px;
`;

const Textarea = styled.textarea`
  width: 100%;
  height: 274px !important;
  padding: 12px 16px;
  border: 1px solid rgba(23, 30, 38, 0.1);
  border-radius: 5px;
  height: 100px;
  resize: none;
  outline: none;
`;

const InputError = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  color: rgba(236, 79, 79, 1);
  margin-top: 4px;
  display: block;
`;

const ContentMaxLength = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  color: rgba(23, 30, 38, 0.4);
  align-self: flex-end;
`;

const SubmitButtonContainer = styled.div`
  padding: 16px 16px 40px;
  width: 100%;
  background-color: #fff;
`;

const SubmitButton = styled.button<{ isComplete: boolean }>`
  width: 100%;
  height: 54px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ isComplete }) => (isComplete ? '#008AFF' : '#f0f0f0')};
  color: ${({ isComplete }) =>
    isComplete ? '#fff' : 'rgba(23, 30, 38, 0.40)'};
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  border: none;
  cursor: pointer;
`;

const Dropdown_List = styled.ul`
  width: 328px;
  border-radius: 8px;
  padding: 8px;
  background-color: #ffffff;
  box-shadow: 0px 4px 15px 0px #8d95a340;
  user-select: none;
  position: absolute;
  list-style: none;
`;

const Dropdown_Item = styled.li`
  width: 100%;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const Dropdown_Item_Text = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;
